"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformProjectSpacingTokenEventToJSON = exports.transformJSONToProjectSpacingTokenEvent = void 0;

var _projectSpacingTokenCreatedEvent = require("./project-spacing-token-created-event");

var _projectSpacingTokenDeletedEvent = require("./project-spacing-token-deleted-event");

var _projectSpacingTokenUpdatedEvent = require("./project-spacing-token-updated-event");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformJSONToProjectSpacingTokenEvent = function transformJSONToProjectSpacingTokenEvent(value) {
  switch (value.action) {
    case 'created':
      return (0, _projectSpacingTokenCreatedEvent.transformJSONToProjectSpacingTokenCreatedEvent)(value);

    case 'deleted':
      return (0, _projectSpacingTokenDeletedEvent.transformJSONToProjectSpacingTokenDeletedEvent)(value);

    case 'updated':
      return (0, _projectSpacingTokenUpdatedEvent.transformJSONToProjectSpacingTokenUpdatedEvent)(value);

    default:
      throw new Error("No variant of ProjectSpacingTokenEvent exists with 'action=".concat(value.action, "'"));
  }
};

exports.transformJSONToProjectSpacingTokenEvent = transformJSONToProjectSpacingTokenEvent;

var transformProjectSpacingTokenEventToJSON = function transformProjectSpacingTokenEventToJSON(value) {
  switch (value.action) {
    case 'created':
      return (0, _projectSpacingTokenCreatedEvent.transformProjectSpacingTokenCreatedEventToJSON)(value);

    case 'deleted':
      return (0, _projectSpacingTokenDeletedEvent.transformProjectSpacingTokenDeletedEventToJSON)(value);

    case 'updated':
      return (0, _projectSpacingTokenUpdatedEvent.transformProjectSpacingTokenUpdatedEventToJSON)(value);
  }
};
/**
 * @type ProjectSpacingTokenEvent
 * This event is used to notify webhooks about changes related to a spacing tokens in the local styleguide of Zeplin projects.
 * @export
 */


exports.transformProjectSpacingTokenEventToJSON = transformProjectSpacingTokenEventToJSON;